export default "__VITE_PUBLIC_ASSET__5f2c0213__"